/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAssignableSubscriptionPlansDto,
} from '../models/index';
import {
    GetAssignableSubscriptionPlansDtoFromJSON,
    GetAssignableSubscriptionPlansDtoToJSON,
} from '../models/index';

/**
 * SubscriptionPlansApi - interface
 * 
 * @export
 * @interface SubscriptionPlansApiInterface
 */
export interface SubscriptionPlansApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansApiInterface
     */
    subscriptionPlansControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssignableSubscriptionPlansDto>>;

    /**
     */
    subscriptionPlansControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssignableSubscriptionPlansDto>;

}

/**
 * 
 */
export class SubscriptionPlansApi extends runtime.BaseAPI implements SubscriptionPlansApiInterface {

    /**
     */
    async subscriptionPlansControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssignableSubscriptionPlansDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription-plans/assignable`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssignableSubscriptionPlansDtoFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionPlansControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssignableSubscriptionPlansDto> {
        const response = await this.subscriptionPlansControllerGetAllRaw(initOverrides);
        return await response.value();
    }

}
